const State = {
  shipList: [],
  shipDeliveryList: []
}

export default State
